import { render, staticRenderFns } from "./secondarySchool.vue?vue&type=template&id=60ca3b56&"
import script from "./secondarySchool.vue?vue&type=script&lang=js&"
export * from "./secondarySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports